<template lang="pug">
  .room.dehumidifier(v-loading="loadingData")
    .divice-block-multi
      SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts1" :series="SinglePieHistogramWrapData1" :class="warningFlag1")
      single-solid-pie.divice-block-multi-item(:opts="SingleSolidPieOpts1" :series="SingleSolidPieData1" :class="warningFlag2")
      single-histogram.divice-block-multi-item(:opts="singleHisOpts1" :series="flowData1" :class="warningFlag3")
      .divice-block-multi-item.divice-block-multi-item-c
        SwitchStatus.divice-block-thin(:title="SwitchStatusTitle1" :series="SwitchStatusData1")
        SwitchStatus.divice-block-thin(:title="SwitchStatusTitle2" :series="SwitchStatusData2")
        RunningTimeBig.divice-block-time(:title="RunningTimeTitle1" :series="RunningTimeData1")
    .divice-block-multi
      SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts2" :series="SinglePieHistogramWrapData2" :class="warningFlag4")
      single-solid-pie.divice-block-multi-item(:opts="SingleSolidPieOpts2" :series="SingleSolidPieData2" :class="warningFlag5")
      single-histogram.divice-block-multi-item(:opts="singleHisOpts2" :series="flowData2" :class="warningFlag6")
      .divice-block-multi-item.divice-block-multi-item-c
        SwitchStatus.divice-block-thin(:title="SwitchStatusTitle3" :series="SwitchStatusData3")
        SwitchStatus.divice-block-thin(:title="SwitchStatusTitle4" :series="SwitchStatusData4")
        RunningTimeBig.divice-block-time(:title="RunningTimeTitle2" :series="RunningTimeData2")
    RefreshBlock(@refreshData="refreshData")
</template>
<script>
import nizhouConfigJSON from './config/highPressureFan_data.json'

export default {
  name: 'highPressureFan',
  data() {
    return {
      timer: null,
      loadingData: false,
      warningFlag1: '',
      warningFlag2: '',
      warningFlag3: '',
      warningFlag4: '',
      warningFlag5: '',
      warningFlag6: '',
      deviceList: [],
      flowData1: {},
      flowData2: {},
      SinglePieHistogramWrapOpts1: {
        title: '高压风机1出口温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapOpts2: {
        title: '高压风机2出口温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapData1: null,
      SinglePieHistogramWrapData2: null,
      SingleSolidPieOpts1: { title: '高压风机1出口压力', max: 15000 },
      SingleSolidPieOpts2: { title: '高压风机2出口压力', max: 15000 },
      SingleSolidPieData1: {},
      SingleSolidPieData2: {},
      singleHisOpts1: {
        title: '高压风机1出口流量',
        histogramName1: 'Flow',
        max: 229,
        sign: 'm³/h'
      },
      singleHisOpts2: {
        title: '高压风机2出口流量',
        histogramName1: 'Flow',
        max: 229,
        sign: 'm³/h'
      },
      RunningTimeData1: null,
      RunningTimeData2: null,
      SwitchStatusData1: null,
      SwitchStatusData2: null,
      SwitchStatusData3: null,
      SwitchStatusData4: null,
      SwitchStatusTitle1: '高压风机1运行',
      SwitchStatusTitle2: '高压风机1故障',
      SwitchStatusTitle3: '高压风机2运行',
      SwitchStatusTitle4: '高压风机2故障',
      RunningTimeTitle1: '高压风机1运行时间',
      RunningTimeTitle2: '高压风机2运行时间'
    }
  },
  created() {
    this.setTitles()
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
    this.resetData()
      this.setTitles()
      this.loadingData = true
      this.getDatas()
    }
  },
  mounted() {
    this.getDatas()
    // this.getInfo()
    this.timer = setInterval(() => {
      this.getDatas()
    }, this.REFRESH_SECOND)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    resetData() {
      this.warningFlag1 = ''
      this.warningFlag2 = ''
      this.warningFlag3 = ''
      this.warningFlag4 = ''
      this.warningFlag5 = ''
      this.warningFlag6 = ''
    },
    setTitles() {
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].deviceList
      const deviceName = nizhouConfigJSON[routerPath[1]][routerPath[2]].deviceName
      this.$set(this.SinglePieHistogramWrapOpts1, 'title', deviceName[0])
      this.$set(this.SingleSolidPieOpts1, 'title', deviceName[1])
      this.$set(this.singleHisOpts1, 'title', deviceName[2])
      this.$set(this.SinglePieHistogramWrapOpts2, 'title', deviceName[3])
      this.$set(this.SingleSolidPieOpts2, 'title', deviceName[4])
      this.$set(this.singleHisOpts2, 'title', deviceName[5])
      this.SwitchStatusTitle1 = deviceName[6]
      this.SwitchStatusTitle2 = deviceName[7]
      this.SwitchStatusTitle3 = deviceName[8]
      this.SwitchStatusTitle4 = deviceName[9]
      this.RunningTimeTitle1 = deviceName[10]
      this.RunningTimeTitle2 = deviceName[11]
    },
    refreshData() {
      this.getDatas()
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.getDatas()
      }, this.REFRESH_SECOND)
    },
    setPieHisData(datas, dataName, data1Id, data2Id, warnName) {
      this[dataName] = {
        data1: datas[data1Id].value,
        data2: datas[data2Id].value
      }
      if (
        datas[data2Id].errorLevel !== 'Normal' &&
        this[warnName] !== 'Error'
      ) {
        this[warnName] = datas[data2Id].errorLevel
      }
      if (
        datas[data1Id].errorLevel !== 'Normal' &&
        this[warnName] !== 'Error'
      ) {
        this[warnName] = datas[data1Id].errorLevel
      }
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find(el => {
        return el.deviceName === deviceName
      })
      if (!device) {
        console.log(`deviceName${deviceName}###`)
      }
      return device.deviceId || ''
    },
    findDeviceData(dataList, deviceName) {
      const deviceId = this.findDeviceId(deviceName)
      const device = dataList[deviceId]
      return {
        value: device.value,
        errorLevel: device.errorLevel
      }
    },
    getInfo() {
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].highPressureFanDeviceList
      const stationId = nizhouConfigJSON[routerPath[1]].highPressureFanStationId
      this.$http
        .get(`/bridge/StationInfo?stationId=${stationId}`)
        .then(res => {
          const __data = res.data.deviceList
          const list = __data.map(el => {
            return {
              deviceId: el.deviceId,
              deviceName: el.deviceName
            }
          })
          console.log('list', JSON.stringify(list))
        })
    },
    getDatas() {
      console.log('getDatas')
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].highPressureFanDeviceList
      const deviceDataName = nizhouConfigJSON[routerPath[1]][routerPath[2]].deviceDataName
      const stationId = nizhouConfigJSON[routerPath[1]].highPressureFanStationId
      this.$http
        .get(`/deviceData/Station?stationId=${stationId}`)
        .then(res => {
          this.loadingData = false
          this.$store.commit('setLastRefreshTime')
          const __data = res.data
          this.setPieHisData(
            __data,
            'SinglePieHistogramWrapData1',
            this.findDeviceId(deviceDataName[0]),
            this.findDeviceId(deviceDataName[1]),
            'warningFlag1'
          )
          const findDeviceData1 = this.findDeviceData(__data, deviceDataName[2])
          const findDeviceData2 = this.findDeviceData(__data, deviceDataName[3])
          const findDeviceData3 = this.findDeviceData(__data, deviceDataName[6])
          const findDeviceData4 = this.findDeviceData(__data, deviceDataName[7])
          this.SingleSolidPieData1 = {
            data1: findDeviceData1.value
          }
          this.warningFlag2 = findDeviceData1.errorLevel
          this.flowData1 = {
            data: findDeviceData2.value
          }
          this.warningFlag3 = findDeviceData2.errorLevel
          this.setPieHisData(
            __data,
            'SinglePieHistogramWrapData2',
            this.findDeviceId(deviceDataName[4]),
            this.findDeviceId(deviceDataName[5]),
            'warningFlag1'
          )
          this.SingleSolidPieData2 = {
            data1: findDeviceData3.value
          }
          this.warningFlag5 = findDeviceData3.errorLevel
          this.flowData2 = {
            data: findDeviceData4.value
          }
          this.warningFlag6 = findDeviceData4.errorLevel
          this.SwitchStatusData1 = {
            data: __data[this.findDeviceId(deviceDataName[8])].value,
            isError: __data[this.findDeviceId(deviceDataName[8])].errorLevel
          }
          this.SwitchStatusData2 = {
            data: __data[this.findDeviceId(deviceDataName[9])].value,
            isError: __data[this.findDeviceId(deviceDataName[9])].errorLevel
          }
          this.SwitchStatusData3 = {
            data: __data[this.findDeviceId(deviceDataName[10])].value,
            isError: __data[this.findDeviceId(deviceDataName[10])].errorLevel
          }
          this.SwitchStatusData4 = {
            data: __data[this.findDeviceId(deviceDataName[11])].value,
            isError: __data[this.findDeviceId(deviceDataName[11])].errorLevel
          }
          this.RunningTimeData1 =
            __data[this.findDeviceId(deviceDataName[12])].value
          this.RunningTimeData2 =
            __data[this.findDeviceId(deviceDataName[12])].value
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.dehumidifier {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  .divice-block-multi {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    &-item {
      width: calc((100% / 4) - 10px);
      background-color: rgba(255, 255, 255, 0.6);
    }
    &-item-c {
      background-color: transparent;
      .divice-block-time{
        height: calc(100% - 96px);
      }
    }
  }
  .divice-block-line {
    width: 100%;
    height: calc(50% - 10px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    &-item {
      width: calc(100% / 2 - 8px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: stretch;
      .divice-block-multi-item {
        width: calc(50% - 7px);
      }
    }
    .divice-block-line-item-col {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &-top {
        display: flex;
        justify-content: space-between;
        &-in {
          display: flex;
          width: calc(50% - 7px);
          flex-direction: column;
          justify-content: space-between;
        }
      }
    }
  }
  .divice-block-thin {
    height: 38px;
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .divice-block-time {
    height: 330px;
    width: 100%;
    box-sizing: border-box;
  }
  .divice-block-multi {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
  }
}
</style>
